import DatePicker from 'react-datepicker';
import { projectListFaja } from "../../../../shared/util/projectList";
import { IActivityValidation } from ".";
import "../styles.scss";
import { Squads } from './processFiles';

export const GeneralTab = ({ validatingData, handleOnChangeValidationData, squads, sortsActivities }: { validatingData: IActivityValidation, handleOnChangeValidationData: any,squads: Squads[], sortsActivities:any[] }) => {

    return (
        <>
            {/* Custom Inputs */}
            <div className='consolidate_files_container_custom_input_container'>
                <div className="consolidate_files_container_custom_input">
                    <label htmlFor="file">Campo : </label>
                    <select id="activity" name="activity" className='Upload_files_container_form_section_select' value={validatingData?.projectId} onChange={(e) => handleOnChangeValidationData(e.target.value, 'projectId')}>
                        <option value=''>Selecciona una opcion</option>
                        {projectListFaja.map((f, index) => <option key={index} value={f.projectId}>{f.name}</option>)}
                    </select>
                </div>
                <div className="consolidate_files_container_custom_input">
                    <label htmlFor="file">Cantidad Actividades : </label>
                    <div className="consolidate_files_container_custom_input_value">{sortsActivities?.length || 0}</div>
                </div>
                <div className="consolidate_files_container_custom_input">
                    <label htmlFor="file">Fecha Ejecucion: </label>
                    <DatePicker
                        selected={validatingData.executedDate}
                        onChange={(date) => handleOnChangeValidationData(date, 'executedDate')}
                        showTimeSelect={false}
                        dateFormat="yyyy-MM-dd"
                        className="consolidate_files_container_custom_input"
                        popperClassName="consolidate_files_container_custom_input_date_picker"
                    />
                </div>
                <div className="consolidate_files_container_custom_input">
                    <label htmlFor="file">N. de Cuadrilla : </label>
                    <input
                        type="number"
                        value={validatingData.squadNumber}
                        onChange={(e) => handleOnChangeValidationData(e.target.value, 'squadNumber')}
                        className="Upload_files_container_form_section_select"
                        min="0"
                        step="1"
                    />
                </div>
                {/* <div className="consolidate_files_container_custom_input">
                    <label htmlFor="file">Tarea Activa : </label>
                    <div className="consolidate_files_container_custom_input_value">{validatingData?.activeTaskId}</div>
                </div> */}
                <div className="consolidate_files_container_custom_input">
                    <label htmlFor="file">Grupo : </label>
                    <div className="consolidate_files_container_custom_input_value">{validatingData?.groupActivityId}</div>
                </div>

            </div>

            {/* Cuadrillas */}
            <div className="consolidate_files_container_v2_cuadrillas_container">
                <div>Cuadrillas</div>
                <div className='consolidate_files_container_v2_table_container' style={{ height: '35vh' }}>
                    <div className='consolidate_files_container_v2_table_header'>
                        <div>Ingenieros</div>
                        <div>Cantidad de actividades</div>
                        <div />
                    </div>
                    <div className="consolidate_files_container_v2_table_info_container">
                        {squads.map((c, i) => (
                            <div className='consolidate_files_container_v2_table_row' key={i}>
                                <div>{c.members.split('/').map((m: string, i: number) => {
                                    return (
                                        <span key={i}>
                                            {c.guestMembers.includes(m.trim()) ? <s style={{ color: 'red' }}>{`${m} / `}</s> : `${m} / `}
                                        </span>
                                    )
                                })}</div >
                                <div>{c.activities}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )

}